import { GuidesPage } from "../../GuidesPage";
import { seoContent } from "../../../../constants/SEOConstant";
import { PairSyncGuideContent } from "../../PairSyncGuideContent";

export default function SyncYoutubeToYoutubeMusic() {
    return (
        <GuidesPage
            seoData={seoContent.syncYoutubeToYoutubeMusic}
            sections={<PairSyncGuideContent sourceKey="youtube" destKey="youtubeMusic" />}
        />
    );
}
